import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar'; // Adjust path to your Navbar component
import '../styles/Layout.css'; // Optional: Add styles
import Header from './Header';

const Layout = () => {
  return (
    <div className="layout">
      <Header />
      <Navbar />
      <main>
        <Outlet /> {/* Renders the current route's component */}
      </main>
    </div>
  );
};

export default Layout;